import "../Main.css";
import axios from "axios";
import { useEffect, useState } from "react";
import ProductAndSolution from "./ProductAndSolution";
import ProductSolutionCard from "../../components/ProductSolutionCard";

export const Solution = () => {
    const [cardList, setCardList] = useState();
    const [titleImage, setTitleImage] = useState();
    const [titleText, setTitleText] = useState();

    useEffect(() => {
        axios.get("/api/solution/title").then((res) => {
            setTitleImage(res.data.imageUrl);
            setTitleText(res.data.name);
        });

        axios.get("/api/solution").then((res) => {
            let cards = [];
            res.data.map((product) => {
                cards.push(
                    <ProductSolutionCard
                        key={product["productID"]}
                        id={product["productID"]}
                        image={product["imageURL"]}
                        name={product["name"]}
                        type={product["type"]}
                        selected_page={7}
                    />
                );
            });
            setCardList(cards);
        });
    }, []);
    return <ProductAndSolution titleImage={titleImage} titleText={titleText} cardList={cardList} selected_page={7} />;
};
